import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductResponse } from '../../services/api.service';
import { CurrencyService } from '../../services/currency.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-most-ordered',
    templateUrl: './most-ordered.component.html',
    styleUrls: ['./most-ordered.component.scss'],
    standalone: false
})
export class MostOrderedComponent implements OnInit, OnDestroy {
  featuredProducts: ProductResponse[] = [];
  currencySymbol: string = '';
  comesFrom: string = 'topProducts';
  private currencySubscription?: Subscription;
  private refreshInterval?: any;
  private lastFeaturedProductsString: string = '';

  constructor(
    private currencyService: CurrencyService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadFeaturedProducts();
    
    // Subscribe to currency changes (needed for currencySymbol input binding)
    this.currencySubscription = this.currencyService.currencySymbol$.subscribe(symbol => {
      this.currencySymbol = symbol;
      this.cdr.detectChanges();
    });

    // Check for featured products updates from background refresh
    this.refreshInterval = setInterval(() => {
      this.checkForFeaturedProductsUpdates();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  private loadFeaturedProducts(): void {
    const cachedFeatured = sessionStorage.getItem('featuredProducts');
    if (cachedFeatured) {
      try {
        this.featuredProducts = JSON.parse(cachedFeatured);
        this.lastFeaturedProductsString = JSON.stringify(this.featuredProducts);
      } catch (error) {
        console.error('Error parsing featured products from sessionStorage:', error);
      }
    }
    
    // Load initial currency symbol for input binding
    const cachedCurrency = sessionStorage.getItem('currencySymbol');
    if (cachedCurrency) {
      this.currencySymbol = cachedCurrency;
    }
  }

  private checkForFeaturedProductsUpdates(): void {
    const cachedFeatured = sessionStorage.getItem('featuredProducts');
    if (cachedFeatured) {
      try {
        const newProducts = JSON.parse(cachedFeatured);
        const newProductsString = JSON.stringify(newProducts);
        
        if (newProductsString !== this.lastFeaturedProductsString) {
          this.featuredProducts = newProducts;
          this.lastFeaturedProductsString = newProductsString;
          this.cdr.detectChanges();
        }
      } catch (error) {
        console.error('Error parsing featured products from sessionStorage:', error);
      }
    } else if (this.featuredProducts.length > 0) {
      this.featuredProducts = [];
      this.lastFeaturedProductsString = '';
      this.cdr.detectChanges();
    }
  }
}
